import React from 'react'

interface IInputProps {
  icon?: React.ReactNode | string
  multiLine?: boolean
  skeleton?: boolean
  block?: boolean
}

const Input: React.FC<IInputProps & React.HTMLProps<HTMLInputElement>> = ({
  icon,
  multiLine,
  block,
  skeleton,
  ...rest
}) =>
  icon ? (
    <div className={`input-wrapper ${skeleton ? 'skeleton' : ''}`}>
      <span className='input-icon'>{icon}</span>
      <input className={`input ${block ? 'block' : ''}`} {...rest} />
    </div>
  ) : (
    <input
      className={`input ${block ? 'block' : ''} ${skeleton ? 'skeleton' : ''}`}
      {...rest}
    />
  )

export default Input
